var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Delete",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_227",
    "data-name": "Rectangle 227",
    width: 32,
    height: 32,
    rx: 16,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash",
    transform: "translate(5.118 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M23.091,6.964A87.936,87.936,0,0,0,5.454,6.741l-2.277.223a.843.843,0,0,1-.927-.759A.832.832,0,0,1,3,5.29l2.277-.223a90.579,90.579,0,0,1,17.983.223.838.838,0,0,1,.748.915.827.827,0,0,1-.826.759Z",
    transform: "translate(-2.246 -0.847)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M8.443,6.229a.841.841,0,0,1-.681-.96l.246-1.462c.179-1.072.424-2.556,3.025-2.556h2.925c2.612,0,2.858,1.54,3.025,2.567l.246,1.451a.832.832,0,1,1-1.641.279L15.341,4.1c-.156-.971-.19-1.161-1.373-1.161H11.044c-1.183,0-1.206.156-1.373,1.15L9.414,5.536a.838.838,0,0,1-.826.7A.687.687,0,0,1,8.443,6.229Z",
    transform: "translate(-1.606 -1.25)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M9.3,24.42c-3.9,0-4.052-2.154-4.175-3.9L4.4,9.283a.839.839,0,0,1,1.674-.112L6.8,20.412c.123,1.7.167,2.333,2.5,2.333h7.166c2.344,0,2.389-.636,2.5-2.333l.726-11.241a.853.853,0,0,1,.893-.781.838.838,0,0,1,.781.893l-.726,11.241c-.123,1.741-.279,3.9-4.175,3.9Z",
    transform: "translate(-1.996 -0.42)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M10.417,17.424a.837.837,0,1,1,0-1.674h3.717a.837.837,0,1,1,0,1.674Z",
    transform: "translate(-1.393 0.436)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M9.587,13.424a.837.837,0,0,1,0-1.674h5.581a.837.837,0,0,1,0,1.674Z",
    transform: "translate(-1.49 -0.029)",
    fill: "#15345a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteSimple);
export default __webpack_public_path__ + "static/media/deleteSimple.efc3b73099cbc228ee4cf0e3336f7ca2.svg";
export { ForwardRef as ReactComponent };